export const SEND_EMAIL_MESSAGE_TO_1SECURITY = /* GraphQL */ `
  mutation sendEmailMessageTo1Security($email: String, $message: String, $recaptchaToken: String!) {
    sendEmailMessageTo1Security(email: $email, message: $message, recaptchaToken: $recaptchaToken)
  }
`;
export default { SEND_EMAIL_MESSAGE_TO_1SECURITY };
